(function () {
  document.querySelectorAll('.template-collection, .template-search').forEach(function (root) {
    var filterToggle = root.querySelector('.template-collection__filter-toggle');
    var filterDrawer = root.querySelector('#bc-sf-filter-tree-h-desktop');
    if (!filterToggle || !filterDrawer || filterToggle.dataset.drawerInitialized) {
      return;
    }
    filterToggle.dataset.drawerInitialized = 'true';
    filterToggle.style.display = 'inline-flex';
    filterToggle.style.gap = '8px';
    filterToggle.style.alignItems = 'center';
    var filterIcon = filterToggle.querySelector('.icon__filter-sliders');
    if (filterIcon) {
      filterIcon.style.width = '1em';
      filterIcon.style.height = '1em';
      filterIcon.style.flex = '0 0 1em';
    }

    var filterOverlay = root.querySelector('.template-collection__filter-overlay');
    var filterResultsButton = filterDrawer.querySelector('.template-collection__filter-results');
    var totalProductElement = root.querySelector('#bc-sf-filter-total-product');
    var appliedFiltersContainer = root.querySelector('.template-collection__applied-filters, .template-search__applied-filters');
    var filterTree = root.querySelector('#bc-sf-filter-tree');
    var previousBodyOverflow;
    var previousBodyPosition;
    var previousBodyTop;
    var previousBodyWidth;
    var filterScrollPosition;

    function alignSelectedFilterItems() {
      root.querySelectorAll('.bc-sf-filter-selection-wrapper .bc-sf-filter-selected-items .selected-item').forEach(function (item) {
        item.style.marginBottom = '0';
        item.style.alignItems = 'center';
      });
      root.querySelectorAll('.bc-sf-filter-selection-wrapper .bc-sf-filter-selected-items .selected-item .selected-type').forEach(function (selectedType) {
        selectedType.style.fontSize = window.matchMedia('(min-width: 768px)').matches ? '16px' : '';
        const clearAll = selectedType.closest('.bc-sf-filter-selection-wrapper').querySelector('.bc-sf-filter-clear-all');
        selectedType.style.fontWeight = clearAll ? window.getComputedStyle(clearAll).fontWeight : 'inherit';
        selectedType.querySelectorAll('strong').forEach((selectedValue) => {
          selectedValue.style.fontWeight = 'inherit';
        });
      });
      root.querySelectorAll('.bc-sf-filter-block-content .noUi-connect').forEach(function (connect) {
        connect.style.backgroundColor = '#555';
      });
    }

    new MutationObserver(alignSelectedFilterItems).observe(root, {
      childList: true,
      subtree: true,
    });
    alignSelectedFilterItems();

    function updateFilterResultsLabel() {
      var totalProductMatch = totalProductElement.textContent.match(/[\d,]+/);
      if (totalProductMatch) {
        filterResultsButton.textContent = theme.strings.filterLabels.showResultsCount.replace('__count__', totalProductMatch[0]);
      }
    }

    if (totalProductElement) {
      new MutationObserver(updateFilterResultsLabel).observe(totalProductElement, {
        childList: true,
        characterData: true,
        subtree: true,
      });
      updateFilterResultsLabel();
    }

    function updateAppliedFilters() {
      var selectedFilters = filterTree.querySelector('.bc-sf-filter-selection-wrapper');
      appliedFiltersContainer.innerHTML = '';
      if (!selectedFilters) {
        return;
      }

      var selectedFiltersClone = selectedFilters.cloneNode(false);
      var selectedItems = selectedFilters.querySelector('.bc-sf-filter-selected-items');
      var clearAll = selectedFilters.querySelector('.bc-sf-filter-clear-all');
      if (selectedItems) {
        selectedFiltersClone.appendChild(selectedItems.cloneNode(true));
      }
      if (clearAll) {
        selectedFiltersClone.appendChild(clearAll.cloneNode(true));
      }

      selectedFiltersClone.querySelectorAll('.selected-type').forEach(function (selectedType) {
        var selectedValue = selectedType.querySelector('strong');
        if (selectedValue) {
          selectedType.textContent = '';
          selectedType.appendChild(selectedValue);
        }
      });
      appliedFiltersContainer.appendChild(selectedFiltersClone);
      updateCollectionSummarySpacing();
    }

    function updateCollectionSummarySpacing() {
      var collectionSummary = root.querySelector('.template-collection__applied-filters .bc-sf-filter-selection-wrapper');
      if (!collectionSummary) {
        return;
      }

      var isTabletUp = window.matchMedia('(min-width: 48rem)').matches;
      var isLargeDesktop = window.matchMedia('(min-width: 64em)').matches;
      collectionSummary.style.padding = isLargeDesktop ? '0 1.5rem' : isTabletUp ? '0 8px' : '';
      collectionSummary.style.marginBottom = isLargeDesktop ? '10px' : '';
    }

    window.addEventListener('resize', function () {
      updateCollectionSummarySpacing();
      alignSelectedFilterItems();
    });

    if (filterTree && appliedFiltersContainer) {
      new MutationObserver(updateAppliedFilters).observe(filterTree, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      updateAppliedFilters();

      appliedFiltersContainer.addEventListener('click', function (event) {
        var selectedItem = event.target.closest('.selected-item');
        var clearAll = event.target.closest('.bc-sf-filter-clear-all');
        if (clearAll) {
          event.preventDefault();
          var originalClearAll = filterTree.querySelector('.bc-sf-filter-clear-all');
          if (originalClearAll) {
            originalClearAll.click();
          }
          return;
        }

        if (selectedItem) {
          event.preventDefault();
          var mirroredItems = appliedFiltersContainer.querySelectorAll('.selected-item');
          var itemIndex = Array.prototype.indexOf.call(mirroredItems, selectedItem);
          var originalItems = filterTree.querySelectorAll('.bc-sf-filter-selection-wrapper .selected-item');
          var originalLink = originalItems[itemIndex] && originalItems[itemIndex].querySelector('a');
          if (originalLink) {
            originalLink.click();
          }
        }
      });
    }

    filterToggle.addEventListener('click', function () {
      if (!filterDrawer.classList.contains('is-collapsed')) {
        return;
      }
      filterScrollPosition = window.scrollY;
      previousBodyOverflow = document.body.style.overflow;
      previousBodyPosition = document.body.style.position;
      previousBodyTop = document.body.style.top;
      previousBodyWidth = document.body.style.width;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + filterScrollPosition + 'px';
      document.body.style.width = '100%';
      filterDrawer.classList.remove('is-collapsed');
      filterToggle.setAttribute('aria-expanded', 'true');
    });

    function closeFilters() {
      if (filterDrawer.classList.contains('is-collapsed')) {
        return;
      }
      document.body.style.overflow = previousBodyOverflow;
      document.body.style.position = previousBodyPosition;
      document.body.style.top = previousBodyTop;
      document.body.style.width = previousBodyWidth;
      window.scrollTo(0, filterScrollPosition);
      filterDrawer.classList.add('is-collapsed');
      filterToggle.setAttribute('aria-expanded', 'false');
      filterToggle.focus();
    }

    filterDrawer.querySelector('.template-collection__filter-close').addEventListener('click', closeFilters);
    filterOverlay.addEventListener('click', closeFilters);
    filterResultsButton.addEventListener('click', closeFilters);
    filterDrawer.querySelector('.template-collection__filter-clear').addEventListener('click', function () {
      var clearAll = filterDrawer.querySelector('.bc-sf-filter-clear-all');
      if (clearAll) {
        clearAll.click();
      }
    });
  });
}());